import CategoryPage from 'components/pages/Category';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import {
  getCategoriesList,
  getCategoryInfo,
  getCategoryOffersList,
} from 'services/category';
import { getLandingsList } from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import CATEGORY from 'constants/category';
import LINKS from 'constants/links';

const Category = ({ category, serverOffers }) => (
  <CategoryPage category={category} serverOffers={serverOffers} />
);

export const getServerSideProps = async ({
  query,
  params: { categorySlug },
}) => {
  try {
    const [
      category,
      serverOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getCategoryInfo({
        categorySlug: categorySlug,
      }),
      getCategoryOffersList({
        categorySlug: categorySlug,
        limit: CATEGORY.OFFERS.SERVER_LIMIT,
        ...query,
      }),
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        category,
        serverOffers,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Category;
